import React, { useContext, useEffect } from 'react';
import './Projects.scss';
import MyContext from '../Context/MyContext';
import { useNavigate } from 'react-router-dom';

const Projects = () => {

  const{token}=useContext(MyContext)

  const Navigate=useNavigate()

  useEffect(()=>{
          !token && Navigate('/login')
      },[])
  const projects = [
    {
      id: 1,
      name: 'E-Commerce Website',
      description:
        'Develop a responsive e-commerce website with features like product listings, shopping cart, and secure payment integration.',
    },
    {
      id: 2,
      name: 'Portfolio Website',
      description:
        'Create a modern and visually appealing portfolio website for showcasing personal projects and professional achievements.',
    },
    {
      id: 3,
      name: 'AI-Powered Recommendation System',
      description:
        'Build a recommendation system using machine learning to suggest products, movies, or content based on user preferences.',
    },
    {
      id: 4,
      name: 'Website Redesign for Accessibility',
      description:
        'Redesign an existing website to ensure it adheres to WCAG accessibility standards, improving usability for all users.',
    },
    {
      id: 5,
      name: 'AI-Powered Virtual Assistant',
      description:
        'Develop a virtual assistant capable of performing tasks like scheduling, answering queries, and providing real-time updates.',
    },
  ];
  

  return (
    <div className="projects-container">
    
      
        {projects.map((project) => (
          <div key={project.id} className="project-card">
            <h3 className="project-name">{project.name}</h3>
            <p className="project-description">{project.description}</p>
          </div>
        ))}
      
    </div>
  );
};

export default Projects;
